"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SWIPER_HEIGHT = exports.NAV_BUTTON_SIZE = void 0;
var NAV_BUTTON_SIZE = exports.NAV_BUTTON_SIZE = 32;
var SWIPER_HEIGHT = exports.SWIPER_HEIGHT = 72;